export default "__VITE_ASSET__jVZjYQlY__"